<template>
  <div class="card m-2">
    <div class="card-header bg-white">プレビュー条件の設定</div>
    <div class="card-body">
      <RadioSelectInput
        :model-value="viewMode"
        :col="{ name: 'viewMode' }"
        :colInputSelection="options"
        @update:modelValue="$emit('update:viewMode', $event)"
      />
    </div>
  </div>
</template>

<script lang="ts">
import RadioSelectInput from '../../../CORE/src/front/ModelForm/ModelInput/RadioSelectInput.vue'

export default {
  name: 'YhcServiceLevelSwitch',
  components: {
    RadioSelectInput,
  },
  props: {
    viewMode: {
      type: String,
      default: 'internal',
    },
  },
  emits: ['update:viewMode'],
  data() {
    return {
      options: [
        { value: 'flea', label: 'フリマ用' },
        { value: 'user', label: 'ユーザー用' },
        { value: 'internal', label: '社内用' },
        { value: 'corporation', label: '法人向け' },
        { value: 'corporationLeadPlusOne', label: 'LT+1日版(法人向け)' },
      ],
    }
  },
}
</script>
<style lang="scss"></style>
